export default __webpack_public_path__ + "static/smartassetlogo-7b0a7e61280dd3d48c2fd84615b437bb.png";